import { z } from "zod";

export const LanguageRuleFieldEnum = z.enum(["profile_language", "personal_country"]);

export const LanguageRuleOperatorEnum = z.enum(["equals", "is_on"]);

export const LanguageRuleConditionSchema = z.union([
	z.object({
		field: LanguageRuleFieldEnum,
		operator: z.literal("equals"),
		value: z.string(),
	}),
	z.object({
		field: LanguageRuleFieldEnum,
		operator: z.literal("is_on"),
		value: z.array(z.string()),
	}),
]);

export const LanguageRuleInfoSchema = z.object({
	id: z.number(),
	companyId: z.number(),
	priority: z.number(),
	conditions: z.array(LanguageRuleConditionSchema),
	outputLanguage: z.string(),
	createdAt: z.string(),
	updatedAt: z.string(),
});

export const LanguageRuleListResponseSchema = z.array(LanguageRuleInfoSchema);

export const CreateLanguageRuleSchema = z.object({
	priority: z.number(),
	conditions: z.array(LanguageRuleConditionSchema),
	outputLanguage: z.string(),
});

export const UpdateLanguageRuleSchema = z.object({
	priority: z.number().optional(),
	conditions: z.array(LanguageRuleConditionSchema).optional(),
	outputLanguage: z.string().optional(),
});

export const ReorderLanguageRulesSchema = z.object({
	items: z.array(
		z.object({
			id: z.number(),
			priority: z.number(),
		})
	),
});

export const EvaluateLanguageRuleRequestSchema = z.object({
	profile_language: z.string().optional(),
	personal_country: z.string().optional(),
});

export const EvaluateLanguageRuleResponseSchema = z.object({
	language: z.string(),
	matchedRuleId: z.number().nullable(),
});

export const DefaultOutputLanguageSchema = z.object({
	defaultOutputLanguage: z.string().nullable(),
});

export type LanguageRuleField = z.infer<typeof LanguageRuleFieldEnum>;
export type LanguageRuleOperator = z.infer<typeof LanguageRuleOperatorEnum>;
export type LanguageRuleCondition = z.infer<typeof LanguageRuleConditionSchema>;
export type LanguageRuleInfo = z.infer<typeof LanguageRuleInfoSchema>;
export type LanguageRuleListResponse = z.infer<typeof LanguageRuleListResponseSchema>;
export type CreateLanguageRule = z.infer<typeof CreateLanguageRuleSchema>;
export type UpdateLanguageRule = z.infer<typeof UpdateLanguageRuleSchema>;
export type ReorderLanguageRules = z.infer<typeof ReorderLanguageRulesSchema>;
export type EvaluateLanguageRuleRequest = z.infer<typeof EvaluateLanguageRuleRequestSchema>;
export type EvaluateLanguageRuleResponse = z.infer<typeof EvaluateLanguageRuleResponseSchema>;
export type DefaultOutputLanguage = z.infer<typeof DefaultOutputLanguageSchema>;
